/*
 * @Author: 周泽飞 zefei.zhou@tongdun.net
 * @Date: 2023-03-08 17:45:01
 * @LastEditors: 周泽飞 zefei.zhou@tongdun.net
 * @LastEditTime: 2023-03-08 19:01:48
 * @FilePath: /tntd/packages/tntd/src/modal/modal.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver'
import type { ModalProps as AntdModalProps } from 'antd/lib/modal'
import classNames from 'classnames'
import { ConfigConsumer } from 'antd/lib/config-provider'

import { default as AntdModal } from 'antd/lib/modal'

export * from 'antd/lib/modal'
export { ActionButtonProps, ModalProps, ModalFuncProps } from 'antd/lib/modal'

export function Modal({ className, ...rest }: AntdModalProps): JSX.Element {
  return (
    <ConfigConsumer>
      {({ getPrefixCls }) => {
        const prefixCls = getPrefixCls('modal')
        return <AntdModal className={classNames(prefixCls, 'tntd-modal', className)} {...rest} />
      }}
    </ConfigConsumer>
  )
}

Modal.info = AntdModal.info
Modal.success = AntdModal.success
Modal.error = AntdModal.error
Modal.warning = AntdModal.warning
Modal.warn = AntdModal.warn
Modal.confirm = AntdModal.confirm
Modal.destroyAll = AntdModal.destroyAll
